export const isUrlValid = (link: string): boolean => {
  {
    const pattern = /https:\/\/docs.google.com\/(spreadsheets|document)\/d\/([a-zA-Z0-9-_]+)/;
    return pattern.test(link);
  }
};
